export const SOCIALS = [
  {
    id: 1,
    value: "https://www.facebook.com/",
    label: "facebook",
  },
  {
    id: 2,
    value: "https://twitter.com/",
    label: "twitter",
  },
  {
    id: 3,
    value: "https://www.linkedin.com/in/",
    label: "linked_in",
  },
  {
    id: 4,
    value: "https://github.com/",
    label: "github",
  },
  {
    id: 5,
    value: "https://www.pinterest.ph/",
    label: "pinterest",
  },
  {
    id: 6,
    value: "https://www.instagram.com/",
    label: "instagram",
  },
]
